import { FormSubmissionCommentService as OvermapFormSubmissionCommentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormSubmissionCommentService extends OvermapFormSubmissionCommentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
